// Content for Equaltoo Foundation — Professional Support Ecosystem

// Large section images are intentionally empty — upload via Admin > Site Content.
// Small decorative avatars kept for testimonials/trust bar until custom photos are uploaded.
export const media = {
  hero: "",
  mentorship: "",
  collaboration: "",
  meeting: "",
  networking: "",
  avatars: [
    "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
    "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
    "https://images.unsplash.com/photo-1780733057909-e40d3f4c8cbe?crop=entropy&cs=srgb&fm=jpg&q=85&w=200"
  ]
};

export const trustBar = [
  { icon: "Gift", label: "Completely Free Membership" },
  { icon: "Users", label: "Peer-to-Peer Learning" },
  { icon: "Scale", label: "Affordable Legal Support" },
  { icon: "Compass", label: "Career Transition Guidance" },
  { icon: "HeartPulse", label: "Wellness Community" },
  { icon: "CalendarDays", label: "Monthly Events" }
];

export const ecosystem = [
  { label: "Professional", icon: "Briefcase" },
  { label: "Career", icon: "Compass" },
  { label: "Legal", icon: "Scale" },
  { label: "Wellbeing", icon: "HeartPulse" },
  { label: "Community", icon: "Users" },
  { label: "Growth", icon: "TrendingUp" }
];

export const supportPillars = [
  {
    title: "Career Transition",
    icon: "Compass",
    accent: "#D4AF37",
    featured: true,
    points: ["Resume Reviews", "Interview Coaching", "Leadership Guidance", "Career Mentoring", "Networking"]
  },
  {
    title: "Legal Awareness",
    icon: "Scale",
    accent: "#003366",
    note: "Specialised legal representation is provided separately by Equaliser Legal when required.",
    points: ["Employment Rights", "Legal Education", "Affordable Consultation", "Will Awareness", "Estate Planning", "Documentation"]
  },
  {
    title: "Wellbeing",
    icon: "HeartPulse",
    accent: "#7CA982",
    points: ["Burnout & Stress", "Mental Wellness", "Peer Conversations", "Support Circles", "Expert Sessions"]
  },
  {
    title: "Professional Community",
    icon: "Users",
    accent: "#E74C3C",
    points: ["Networking & Forums", "Peer Learning", "Mentorship", "Women Leaders", "Young & Senior Leaders"]
  },
  {
    title: "Knowledge Hub",
    icon: "BookOpen",
    accent: "#003366",
    points: ["Webinars & Podcasts", "Legal Awareness", "Career Guides", "Templates", "Articles"]
  }
];

export const differences = [
  { title: "Professionals helping Professionals", icon: "Handshake" },
  { title: "Knowledge before Advice", icon: "Lightbulb" },
  { title: "Trusted Legal Network", icon: "ShieldCheck" },
  { title: "Completely Independent", icon: "Feather" },
  { title: "Not-for-Profit", icon: "Heart" },
  { title: "Community Driven", icon: "Users" },
  { title: "Affordable Expert Help", icon: "BadgeIndianRupee" },
  { title: "Built for Corporate India", icon: "Building2" }
];

export const creditFlow = [
  { label: "Learn", icon: "GraduationCap" },
  { label: "Share", icon: "Share2" },
  { label: "Volunteer", icon: "HandHeart" },
  { label: "Earn Credits", icon: "Coins" },
  { label: "Redeem", icon: "Gift" }
];

export const creditRedeem = [
  "Priority Events", "Expert Sessions", "Legal Discounts", "Exclusive Workshops", "Recognition"
];

export const events = [
  { date: "12 Jul", title: "Career Clinic: Switching Industries", tag: "Career", format: "Online" },
  { date: "19 Jul", title: "Know Your Employment Rights", tag: "Legal Awareness", format: "Online" },
  { date: "26 Jul", title: "Women Leaders Networking Evening", tag: "Networking", format: "Offline" },
  { date: "02 Aug", title: "Beating Burnout: A Wellness Circle", tag: "Mental Wellness", format: "Online" },
  { date: "09 Aug", title: "Resume Clinic with Senior Recruiters", tag: "Resume", format: "Hybrid" },
  { date: "16 Aug", title: "Will & Estate Planning Awareness", tag: "Will Awareness", format: "Online" }
];

export const impact = [
  { label: "Members", value: 12000, suffix: "+" },
  { label: "Volunteer Mentors", value: 850, suffix: "+" },
  { label: "Sessions Conducted", value: 1400, suffix: "+" },
  { label: "Legal Awareness Sessions", value: 320, suffix: "+" },
  { label: "Community Hours", value: 45000, suffix: "+" },
  { label: "Lives Impacted", value: 60000, suffix: "+" }
];

export const memberStories = [
  { quote: "I found my next opportunity.", name: "Ananya R.", role: "Product Manager, Bengaluru", avatar: media.avatars[0] },
  { quote: "I finally understood my employment rights.", name: "Vikram S.", role: "Operations Lead, Pune", avatar: media.avatars[1] },
  { quote: "I finally drafted my Will.", name: "Meena K.", role: "Finance Director, Mumbai", avatar: media.avatars[2] },
  { quote: "I met mentors who changed my career.", name: "Arjun T.", role: "Software Engineer, Hyderabad", avatar: media.avatars[0] },
  { quote: "This community helped me through burnout.", name: "Sara D.", role: "Marketing Manager, Delhi", avatar: media.avatars[1] }
];

export const willPoints = ["Will Planning", "Nomination", "Estate Planning", "Power of Attorney", "Family Protection"];

// Corporate Life Series
export const corporateSeries = [
  { month: "January", topic: "Employment Rights & Workplace Laws", icon: "Scale" },
  { month: "February", topic: "Career Transitions & Job Search Strategies", icon: "Compass" },
  { month: "March", topic: "Leadership & Executive Presence", icon: "Crown" },
  { month: "April", topic: "Mental Wellbeing & Resilience", icon: "HeartPulse" },
  { month: "May", topic: "Personal Finance & Tax Basics", icon: "BadgeIndianRupee" },
  { month: "June", topic: "Will Planning & Estate Planning", icon: "FileSignature" },
  { month: "July", topic: "Retirement Readiness", icon: "Sunset" },
  { month: "August", topic: "Entrepreneurship After Corporate Life", icon: "Rocket" }
];

// Knowledge Hub categories
export const knowledgeCategories = [
  { title: "Career Transition", icon: "Compass", count: 24 },
  { title: "Employment Law", icon: "Scale", count: 18 },
  { title: "Workplace Rights", icon: "ShieldCheck", count: 15 },
  { title: "Mental Wellness", icon: "HeartPulse", count: 21 },
  { title: "Leadership", icon: "Crown", count: 19 },
  { title: "Networking", icon: "Users", count: 12 },
  { title: "Will Planning", icon: "FileSignature", count: 9 },
  { title: "Estate Planning", icon: "Landmark", count: 8 }
];

export const knowledgeFormats = [
  { title: "Templates", icon: "FileText" },
  { title: "Downloads", icon: "Download" },
  { title: "Videos", icon: "PlayCircle" },
  { title: "Podcasts", icon: "Mic" },
  { title: "Webinars", icon: "MonitorPlay" }
];

// Membership form options
export const helpOptions = ["Career", "Networking", "Legal Awareness", "Wellbeing", "Learning", "Mentorship", "Events", "Volunteer"];

export const contributionOptions = [
  "Career Mentoring", "Resume Reviews", "Interview Coaching", "Leadership", "Legal Awareness",
  "Public Speaking", "Finance", "Tax", "Technology", "AI", "Marketing", "Entrepreneurship",
  "Women Leadership", "Mental Wellness", "Life Coaching", "Parenting", "HR", "Compliance",
  "Corporate Governance", "Learning Sessions", "Industry Insights", "Networking", "Panel Discussions", "Other"
];

export const sessionOptions = ["1", "2", "4", "6", "12", "Flexible"];
export const formatOptions = ["Online", "Offline", "Hybrid"];
export const audienceOptions = ["Students", "Young Professionals", "Mid Career", "Senior Leaders", "Women Professionals", "Entrepreneurs", "Everyone"];

export const legalDisclaimer = "Equaltoo Foundation is a non-profit organisation focused on awareness, education and community support. Where specialised legal representation or drafting services are required, members may choose to engage Equaliser Legal or any legal professional of their choice. This maintains the independence of the Foundation while ensuring members have access to trusted legal expertise when needed.";

export const DEFAULT_LOGO = "https://customer-assets.emergentagent.com/job_20414c3a-9623-4d12-8f24-8780a5aa64c8/artifacts/y936iv32_%3D2_transparent_logo.png";

// Fixed icon/accent metadata for Home (not user-editable). Text comes from CMS.
export const homeIcons = {
  trustBar: trustBar.map((t) => t.icon),
  ecosystem: ecosystem.map((e) => e.icon),
  pillars: supportPillars.map((p) => ({ icon: p.icon, accent: p.accent, featured: !!p.featured })),
  differences: differences.map((d) => d.icon),
  creditFlow: creditFlow.map((c) => c.icon)
};

// ─── Default editable content — CMS values are deep-merged over these ──────────
// Images are empty strings; upload via Admin > Site Content to avoid stock-photo flash.

export const defaultHomeContent = {
  logo: DEFAULT_LOGO,
  hero: {
    badge: "India's Professional Support Ecosystem",
    headlinePre: "Because Professional Success Shouldn't Come at the Cost of Your ",
    headlineHighlight: "Wellbeing.",
    subtext: "Supporting corporate professionals across every stage of their career through trusted community support, peer mentoring, legal awareness, career transition guidance and wellbeing initiatives.",
    ctaPrimary: "Join Free Community",
    ctaSecondary: "Become a Volunteer",
    exploreLabel: "Explore Community",
    image: "",
    statNumber: "12,000+",
    statLabel: "professionals growing together"
  },
  trustBar: trustBar.map((t) => t.label),
  whoWeAre: {
    eyebrow: "Who We Are",
    headingLine1: "More Than A Community.",
    headingHighlight: "A Professional Support Ecosystem.",
    para1: "Corporate professionals spend years building careers but often face challenges they never expected — career uncertainty, legal issues, burnout, workplace disputes, family responsibilities and financial stress. Finding trusted guidance can be expensive and confusing.",
    para2: "Equaltoo exists to change that. We are building India's first non-profit community where professionals help professionals through mentoring, networking, knowledge sharing, affordable legal access and peer support."
  },
  ecosystem: ecosystem.map((e) => e.label),
  support: {
    eyebrow: "How We Support You",
    heading: "Five pillars, one community.",
    pillars: supportPillars.map((p) => ({ title: p.title, note: p.note || "", points: p.points }))
  },
  difference: {
    eyebrow: "Our Difference",
    heading: "Why Equaltoo is Different",
    items: differences.map((d) => d.title)
  },
  will: {
    eyebrow: "Family Protection",
    heading: "Protect Your Family Before Life Makes the Decision.",
    para: "Most professionals spend years creating wealth. Very few create a legally valid Will. Equaltoo conducts awareness sessions helping professionals understand what matters most.",
    note: "Professional legal drafting is available through Equaliser Legal at highly subsidised pricing.",
    cta: "Learn About Will Planning",
    points: willPoints
  },
  community: {
    eyebrow: "Community Model",
    heading: "Join. Share. Support. Grow.",
    para: "Every professional has something valuable to contribute. Members are encouraged to both learn and give back — through mentoring, webinars, networking, coaching and peer discussions. The stronger the community becomes, the stronger every member becomes.",
    flow: creditFlow.map((c) => c.label),
    redeem: creditRedeem
  },
  events: {
    eyebrow: "Upcoming Events",
    heading: "Learn together, every month."
  },
  impact: {
    eyebrow: "Our Impact",
    heading: "Built by professionals, for professionals.",
    stats: impact.map((s) => ({ value: s.value, suffix: s.suffix, label: s.label }))
  },
  testimonials: {
    eyebrow: "Real Stories",
    heading: "Where professionals find their footing.",
    items: memberStories.map((m) => ({ quote: m.quote, name: m.name, role: m.role }))
  },
  finalCta: {
    headingLine1: "Together We Build Better Careers.",
    headingLine2: "Stronger Communities. Secure Families.",
    subtext: "Join Equaltoo today — membership is completely free, always.",
    cta: "Join Equaltoo Today"
  }
};

// Pillar images start empty — upload via Admin > Site Content > How We Help
export const hwhPillarImages = ["", "", "", "", ""];

export const defaultHowWeHelpContent = {
  hero: {
    eyebrow: "How We Help",
    heading: "Five ways we walk with you — through every stage of professional life.",
    subtext: "Equaltoo isn't a single service. It's an ecosystem of support built by professionals, for professionals — so no one has to navigate careers, life or legal challenges alone."
  },
  pillars: supportPillars.map((p, i) => ({ title: p.title, note: p.note || "", points: p.points, image: hwhPillarImages[i] })),
  difference: {
    heading: "What makes our help different",
    items: differences.map((d) => d.title)
  },
  ctaHeading: "Whatever you're facing, you don't have to face it alone."
};

export const defaultAboutContent = {
  hero: {
    title: "About Equaltoo Foundation",
    subtext: "India's first non-profit support ecosystem for corporate professionals — community, peer learning, legal awareness, career transition and wellbeing, all in one place."
  },
  mission: [
    {
      title: "What we do",
      description: "Equaltoo is building India's first non-profit community where professionals help professionals — through mentoring, networking, knowledge sharing, wellbeing support, legal awareness and affordable access to expert legal guidance when needed. Community first, support first, knowledge first, legal help when required.",
      image: ""
    },
    {
      title: "Why we do it",
      description: "Corporate professionals spend years building careers but face challenges they never expected — career uncertainty, legal issues, burnout, workplace disputes, family responsibilities and financial stress. Trusted guidance is often expensive and confusing. Equaltoo exists to change that.",
      image: ""
    },
    {
      title: "Our purpose",
      description: "Helping professionals navigate careers, life and legal challenges together. We are a Section 8 non-profit supporting corporate professionals across every stage of their journey — not just when they face a problem, but through every transition, milestone and moment of growth.",
      image: ""
    }
  ],
  team: {
    heading: "Our Leadership",
    subtext: "Meet the dedicated professionals leading the movement for professional wellbeing.",
    members: [
      { name: "Amit Chanana", role: "Founder", bio: "20+ years across corporate leadership, dedicated to building support systems for professionals.", image: "" },
      { name: "Team Equaltoo", role: "Core Team", bio: "A team of professionals committed to building India's first non-profit support ecosystem.", image: "" }
    ]
  },
  certifications: {
    heading: "Certifications & Recognition",
    items: [
      { title: "NGO Darpan", description: "Registered and recognized by the Government of India" },
      { title: "12A Certified", description: "Income Tax Act exemption certification" },
      { title: "80G Certified", description: "Tax benefits for donors under Indian Income Tax Act" }
    ]
  }
};

export const defaultContactContent = {
  hero: { title: "Talk to Us", subtext: "Questions about the community, events or volunteering? We're here to help and we'd love to hear from you." },
  formHeading: "Send us a Message",
  formSubtext: "Fill out the form and our team will get back to you within 24 hours.",
  infoHeading: "Get in Touch",
  infoText: "We're here to support you. Whether you have questions about our services, membership, or just want to learn more about Equaltoo, feel free to reach out.",
  office: "New Delhi, India",
  phone: "+91 7206689787",
  email: "amit@equaltoo.org.in",
  hours: "Monday - Friday: 9:00 AM - 6:00 PM\nSaturday: 10:00 AM - 4:00 PM\nSunday: Closed",
  mapImage: ""
};

export const defaultDonateContent = {
  hero: {
    title: "Support the Movement",
    subtext: "Equaltoo is a not-for-profit built by professionals, for professionals. Your contribution keeps every session, mentorship and legal-awareness programme free for the community."
  },
  image: "",
  intro: "Individuals and corporates can support Equaltoo Foundation through a direct bank transfer. Every rupee funds free career, wellbeing and legal-awareness sessions for professionals across India.",
  taxNote: "Equaltoo Foundation is a Section 8 non-profit. Donations are eligible for tax benefits under 80G of the Income Tax Act.",
  bank: {
    heading: "Bank Transfer Details",
    accountName: "Equaltoo Foundation",
    accountNumber: "",
    bankName: "",
    ifsc: "",
    branch: "",
    upi: ""
  },
  corporateHeading: "For Corporates & CSR",
  corporateText: "Partner with us for CSR initiatives, employee wellbeing programmes and sponsored sessions. Write to us and our team will share a tailored proposal.",
  contactEmail: "amit@equaltoo.org.in",
  razorpayComingSoon: true
};

// ─── New page defaults ────────────────────────────────────────────────────────

export const defaultCorporateLifeSeriesContent = {
  hero: {
    badge: "Our Signature Initiative",
    titlePre: "The ",
    titleHighlight: "Corporate Life Series",
    subtitle: "A structured calendar of free monthly sessions covering the topics professionals rarely receive guidance on. Because Equaltoo supports professionals through every stage of their career and life — not just when they face a problem.",
    cta: "Reserve Your Free Seat"
  },
  series: corporateSeries.map((s) => ({ month: s.month, topic: s.topic })),
  closing: {
    heading: "A reason to keep returning — and to bring a colleague.",
    subtext: "Every session is free, practical and led by experienced professionals from the community.",
    cta: "Join Free Community"
  }
};

export const defaultServicesContent = {
  hero: {
    heading: "How We Help",
    subtext: "Five pillars, one community — supporting professionals through careers, legal awareness, wellbeing, connection and knowledge."
  },
  services: [
    { id: "1", title: "Career Transition", description: "Peer mentoring and practical guidance for every stage of your career — from switching industries to stepping into leadership.", features: ["Resume Reviews", "Interview Coaching", "Leadership Guidance", "Career Mentoring & Networking"], icon: "Briefcase" },
    { id: "2", title: "Legal Awareness", description: "Understand your rights and options. Education and affordable consultation — specialised representation via Equaliser Legal when required.", features: ["Employment Rights", "Legal Education", "Will & Estate Awareness", "Affordable Consultation"], icon: "Scale" },
    { id: "3", title: "Wellbeing", description: "A supportive community for the harder parts of professional life — burnout, stress and mental wellness.", features: ["Burnout & Stress Support", "Peer Conversations", "Support Circles", "Expert Sessions"], icon: "Heart" },
    { id: "4", title: "Professional Community", description: "Connect, learn and grow with professionals across industries through forums, mentorship and events.", features: ["Networking & Forums", "Peer Learning", "Mentorship", "Women & Young Leaders"], icon: "Users" },
    { id: "5", title: "Knowledge Hub", description: "A growing library of guidance professionals rarely get — free for the community.", features: ["Webinars & Podcasts", "Career Guides", "Templates & Downloads", "Articles"], icon: "BookOpen" }
  ],
  howItWorksHeading: "How Our Services Work",
  steps: [
    { step: "1", title: "Join as Member", desc: "Sign up — membership is completely free" },
    { step: "2", title: "Connect with Expert", desc: "Get matched with the right professional" },
    { step: "3", title: "Receive Support", desc: "Access personalised guidance and resources" },
    { step: "4", title: "Grow & Thrive", desc: "Build your career with ongoing support" }
  ],
  cta: {
    heading: "Ready to Access These Services?",
    subtext: "Become a member today and get access to all our professional support services",
    button: "Join Now"
  }
};

export const defaultKnowledgeHubContent = {
  hero: {
    eyebrow: "Knowledge Hub",
    heading: "Guidance professionals rarely get — now in one place.",
    subtext: "Practical, trusted resources on careers, employment law, wellbeing, leadership and family protection — created by professionals, for professionals."
  },
  formatsHeading: "Learn the way that suits you",
  bottomCta: {
    heading: "New resources every week — free for members.",
    button: "Join Free to Access"
  }
};

export const defaultMembershipContent = {
  hero: {
    badge: "Membership is always free",
    heading: "Become a",
    headingHighlight: "Founding Member",
    subtext: "Equaltoo exists because professionals help professionals. We ask every member to contribute in whatever way they can — sometimes knowledge, sometimes mentoring, sometimes simply listening."
  },
  contributionSection: {
    eyebrow: "Give back",
    heading: "How would YOU like to contribute to the community?",
    subtext: "Select all the areas where you'd be happy to share your experience."
  }
};

export const defaultEventsContent = {
  hero: {
    eyebrow: "Events & Programs",
    heading: "Learn, connect and grow — every single month.",
    subtext: "Free career clinics, legal awareness sessions, wellness circles and networking evenings — open to the whole community. Reserve your seat in seconds."
  },
  clsCard: {
    heading: "The Corporate Life Series",
    subtext: "A structured calendar of free monthly sessions across employment rights, leadership, wellbeing, finance, will planning and more.",
    cta: "Explore the Series"
  }
};
